import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";

const utils = createTrackingUtils({
  name: "flights_web_budget_layover_airports_filters",
  stages: {
    tech: 1,
    any_new_filter_available: 2,
    any_new_filter_in_viewport: 3,
    shorthaul: 4,
    midhaul: 5,
    longhaul: 6,
    us: 7
  },
  defaultStage: 3,
  goals: {
    interactedWithBudgetFilter: 1,
    interactedWithLayoverFilter: 2,
    interactedWithAirportsFilter: 3
  }
});

export const useTrackNewFilters = (isNewFilterAvailable: boolean) => {
  const { stages } = utils;
  const { isShortHaul, isMediumHaul, isLongHaul } = useProfiler();

  if (!isNewFilterAvailable) return;

  stages.any_new_filter_available();
  isShortHaul() && stages.shorthaul();
  isMediumHaul() && stages.midhaul();
  isLongHaul() && stages.longhaul();
};

export default utils;
